import { formatAdminAccountMoney } from '../../types/account';
import type { UgotProRefundRequest } from '../../ugotPro/ugotProTypes';
import { formatUgotProDateTime } from '../../ugotPro/ugotProFormat';

/** 환불 요청의 금액·사유·자동 판정 근거(policyEvidence)·처리 기록. */
export function UgotProRefundEvidence({ refund }: { refund: UgotProRefundRequest }) {
  return (
    <div className="space-y-1 text-sm">
      <div className="grid gap-x-4 gap-y-1 text-muted-foreground sm:grid-cols-2">
        <div>원금액: {formatAdminAccountMoney(refund.originalAmount, refund.currency)}</div>
        <div>환불액: {refund.refundAmount === null ? '-' : formatAdminAccountMoney(refund.refundAmount, refund.currency)}</div>
        <div className="break-all">주문: {refund.orderId}</div>
        <div className="break-all">대상 거래: {refund.providerTransactionId || '-'}</div>
        {refund.adjustmentId && <div className="break-all">Paddle adjustment: {refund.adjustmentId}</div>}
        {refund.processedAt && (
          <div className="break-all">처리: {refund.processedBy || '-'} · {formatUgotProDateTime(refund.processedAt)}</div>
        )}
      </div>
      <div className="break-words"><span className="text-muted-foreground">사유: </span>{refund.reason || '-'}</div>
      {refund.policyEvidence && (
        <pre className="whitespace-pre-wrap break-all rounded-md bg-muted px-2 py-1.5 font-mono text-xs" data-testid="ugot-pro-policy-evidence">
          {refund.policyEvidence}
        </pre>
      )}
      {refund.adminNotes && <div className="break-words"><span className="text-muted-foreground">관리자 메모: </span>{refund.adminNotes}</div>}
    </div>
  );
}
